import { render, staticRenderFns } from "./LayoutPweb.vue?vue&type=template&id=73827dfe&"
import script from "./LayoutPweb.vue?vue&type=script&lang=js&"
export * from "./LayoutPweb.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPweb.vue?vue&type=style&index=0&id=73827dfe&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports